import appReducer from './appReducer'
import metaDataReducer from './metaDataReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import serviceAvailableReducer from './apiReducers/serviceAvailableReducer'
import fineOweAmountReducer from './apiReducers/fineOweAmountReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  app: appReducer,
  metaData: metaDataReducer,
  authentication: authenticationReducer,
  register: registerReducer,
  serviceAvailable: serviceAvailableReducer,
  fineOweAmount: fineOweAmountReducer,
})

export default rootReducer
